import ArticleVariant from '@/modules/content/loop/variants/ArticleVariant';
import PostVariant from '@/modules/content/loop/variants/PostVariant';
import ReelVariant from '@/modules/content/loop/variants/ReelVariant';
import { TLoopVariantProps } from '@/modules/content/loop/model/types';

// One item of the loop. Each content type gets a different layout — and video additionally
// gets a different one per orientation, resolved inside ReelVariant.
const FocusedLoopItem = (props: TLoopVariantProps) => {
  if (props.content.type === 'video') return <ReelVariant {...props} />;
  if (props.content.type === 'article') return <ArticleVariant {...props} />;

  return <PostVariant {...props} />;
};

export default FocusedLoopItem;
